<template>
		<div class="content home-page">
		<Header></Header>
      <div class="" @click="back" style="text-align: left;;align-items: center;justify-content: center;">
        <img style="width: 1.5rem;margin-left: 1rem" src="../../static/images/back.png" />
      </div>
			<div class="info crfff">
        <div class="fs50 mt50 ac">{{$t('PurchaseChances')}}</div>
<!--        <div class="fs22 mt20 ac">{{$t('purchaseTips1')}} : {{score}}</div>-->
        <div class=" list">
          <div class="li" :class="{'disabled':!isShow}" @click="getBuy('oneTime1')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('buy_tip1')}}</strong>
            </div>
          </div>
          <div class="li" :class="{'disabled':!isShow}" @click="getBuy('oneTime2')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('buy_tip2')}}</strong>
            </div>
          </div>
          <div class="li" :class="{'disabled':!isShow}" @click="getBuy('oneTime3')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('buy_tip3')}}</strong>
            </div>
          </div>
        </div>
			</div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal ac" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;">
                <img width="70" src="../../static/images/close.png" />
              </div>
              <div class="por" style="width: 340px;padding: 20px;margin: 0 auto;background: #1a266a;box-shadow: 0 0 30px #f4c214;border-radius: 100%;">
                <img width="300" src="../../static/images/img1.png" />
                <div class="circle"></div>
              </div>
              <div class="fs33 mt50 ac">{{$t('purchaseTips2')}}</div>
              <div class="fs26 ac" v-html="$t('purchaseTips3')"></div>
              <button class="button mt30" @click="getBuy(2)">{{$t('BuyNow')}}!</button>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:true,
       score:'',
        num:1,
        info:{}
      }
    },
	created(){
		this.getUserInfo();
	},
  methods: {
		back(){
			this.$router.go(-1);
		},
		getUserInfo(){
			let that =this;
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score = r.data.score
				});
			})
		},
    getBuy(type){
      let that = this
      let data = {
        type:type
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/buy/onetime',data,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          // that.$utils.alertText(r.msg,100,3000);
          // that.score = r.data.score
          window.location.href = r.data.url;
        });
      })
    },
    closeTmgDialog(){
      this.$refs.imgDialog.closeMask();
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/purchaseChances.vue